const GA_EVENTS = {
  clickToCall: 'clickToCall',
}

function triggerDataLayerEvent(eventName) {
  return function () {
    if (typeof window !== 'undefined') {
      try {
        window.dataLayer.push({ event: eventName })
      } catch (e) {
        // ignore
      }
    }
    return true
  }
}

$(document).ready(() => {
  $('#GA_clickToCall').on('click', triggerDataLayerEvent(GA_EVENTS.clickToCall))

  $('.fb-pixel-lead-trigger').click(() => {
    if ('fbq' in window) {
      window.fbq('track', 'Lead')
    }
  })

  $('#GA_clickToCall').click(() => {
    /**
     * BRUM-4583 il lead al clicktocall
     * si invia solo se presente
     * il cookie
     */
    if (window.Cookies && window.Cookies.get('accesstime')) {
      $.ajax({
        url: `${window.brumbrum.url_api}/lead/p/v3/click_to_call`,
        method: 'POST',
        contentType: 'application/json; charset=utf-8',
        data: JSON.stringify({
          privacy: 'ko',
          accesstime: window.Cookies.get('accesstime'),
          utmfollower: window.Cookies
            ? window.Cookies.getJSON('utmfollower')
            : null,
          referrer: typeof document !== 'undefined' ? document.referrer : null,
        }),
      })
    }
  })
  $('body').removeClass('loading-page')
})
